import React from 'react';
import Routes from '../../consts/Routes';
import CTButton from './CTButton';

const MyProfileButton = () => {
  return <CTButton pushParams={Routes.MY_PROFILE}>My Profile</CTButton>;
};

export default MyProfileButton;
